import React from 'react'
import { Link } from 'react-router-dom'

import {
  Heading,
  TopPanel,
  OuterLinkWrap,
  NavigationLink,
  LinksWrap,
  ContentWrapInner,
} from './styled'
import { useQuizzesData } from './hooks/useQuizzesData'

import QuizList from 'src/components/QuizList/QuizList'
import Layout from 'src/components/Layout/Layout'
import { QUIZZES_NEW, QUIZZES_COMPLETED } from 'src/constants/routes'
import { LoadingBlock } from 'src/components/Loading'

const CompletedQuizzes: React.FC = () => {
  const { isLoading, quizzesData } = useQuizzesData('completed')

  return (
    <Layout>
      <ContentWrapInner>
        <TopPanel>
          <Heading>Quizzes</Heading>
          <LinksWrap>
            <OuterLinkWrap>
              <Link to={QUIZZES_NEW}>
                <NavigationLink>New</NavigationLink>
              </Link>
            </OuterLinkWrap>
            <OuterLinkWrap>
              <Link to={QUIZZES_COMPLETED}>
                <NavigationLink isActive>Completed</NavigationLink>
              </Link>
            </OuterLinkWrap>
          </LinksWrap>
        </TopPanel>
        {isLoading ? (
          <LoadingBlock />
        ) : (
          <QuizList quizzes={quizzesData?.data ?? []} complete />
        )}
      </ContentWrapInner>
    </Layout>
  )
}

export default CompletedQuizzes
